import getSuggestionAtIndex from './getSuggestionAtIndex';
import { SearchScenarioId } from 'owa-search-next-common';
import { SubstrateSearchSuggestionSegment, SuggestionKind } from 'owa-search-service';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Returns the display text for the suggestion at the given index.
 * @param index The target suggestion's index
 * @returns The display text of the target suggestion
 */
export default function getSuggestionText(index: number, scenarioId: SearchScenarioId) {
    // If no suggestion exists at given index, return an empty string.
    const suggestion = getSuggestionAtIndex(index, scenarioId);
    if (!suggestion) {
        return '';
    }

    switch (suggestion.kind) {
        case SuggestionKind.Category:
            return suggestion.Name;
        case SuggestionKind.Files:
            return suggestion.Name;
        case SuggestionKind.Keywords:
            if (isFeatureEnabled('sea-gf') && suggestion.Segments) {
                return (
                    suggestion.Segments.map((segment: SubstrateSearchSuggestionSegment) => {
                        switch (segment.Type) {
                            case 'Person':
                                return segment.DisplayName;
                            case 'Text':
                                return segment.Text || '';
                            default:
                                return '';
                        }
                    })
                        // Remove null segment text parts.
                        .filter(segmentTextPart => segmentTextPart)
                        // Join segment text parts with a space.
                        .join(' ')
                );
            } else {
                return suggestion.QueryText;
            }
        case SuggestionKind.People:
            return suggestion.DisplayName;
        default:
            return '';
    }
}
